
import { Box, Checkbox, Typography } from "@mui/joy";
import { useState } from "react";

function CheckBoxAutoForm(props) {
    const { defaultValue, labelMinWidth, label, disabled, name } = props;
    const [checked, setChecked] = useState(defaultValue === "false" ? false : defaultValue); // Default value COULD be a string of "false". convert into bool

    return <Box sx={{display: "flex"}}>
        <Typography sx={{minWidth: labelMinWidth, alignSelf: "center", paddingRight: 1}}>
            {label}: 
        </Typography>
        <Checkbox
            defaultChecked={defaultValue}
            disabled={disabled}
            checked={checked}
            onChange={(event) => {
                setChecked(event.target.checked);
            }}
        />
        <input type="hidden" name={name} value={checked} />
    </Box>
}

export default CheckBoxAutoForm;